import OrganizationUpdateModal from "./OrganizationUpdateModal"

export default OrganizationUpdateModal
